import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';
import * as diaryNotesActions from 'src/app/store/actions/diary-notes.action';
import * as medicationSchemeActions from 'src/app/store/actions/medication.action';
import { PrescriptionsApiActions, PrescriptionsStoreActions } from 'src/app/store/actions/prescriptions.action';
import {
  DeliveredMedicationsApiActions,
  DeliveredMedicationsStoreActions
} from '../actions/delivered-medication.action';
import * as userActions from '../actions/user.action';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
  ) {}

  fetchAllPatientMedicalData$ = createEffect(() => this.actions$.pipe(
    ofType(userActions.fetchAllPatientMedicalData),
    switchMap(action => [
      diaryNotesActions.fetchDiaryNotesCountAction(),
      PrescriptionsApiActions.fetchCount(),
      DeliveredMedicationsApiActions.fetchCount()
    ])
  ));

  clearAllPatientMedicalData$ = createEffect(() => this.actions$.pipe(
    ofType(userActions.clearAllPatientMedicalData),
    switchMap(() => [
      diaryNotesActions.clearDiaryNotesAction(),
      medicationSchemeActions.clearMedicationAction(),
      PrescriptionsStoreActions.clearPrescriptions(),
      DeliveredMedicationsStoreActions.clearDeliveredMedications(),
    ])
  ));
}
